<template>
  <div>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <span class="card-title wise-card-title">주문정보</span>
            <b-button variant="primary" style="float: right;" v-on:click="openUserInfoModal()">회원검색</b-button>
          </div>
          <b-row class="pt-2">
            <b-col sm="12">
              <table class="table table-bordered oddBackground">
                    <tbody>
                        <tr>
                          <td style="width:15%; vertical-align: middle;">주문자 ID</td>
                            <td class="tl">
                                <input type="text" v-model="userInfoOptions.user_id" style="width: 90%;" class="form-control" />
                            </td>
                        </tr>
                        <tr>
                            <td style="width:15%; vertical-align: middle;">주문자 이름</td>
                            <td class="tl">
                                <input type="text" v-model="userInfoOptions.name" style="width: 90%;" class="form-control" />
                            </td>
                        </tr>
                        <tr>
                            <td style="width:15%; vertical-align: middle;">전화번호</td>
                            <td class="tl">
                                <input type="text" v-model="userInfoOptions.mobile" style="width: 90%;" class="form-control" />
                            </td>
                        </tr>
                        <tr>
                            <td style="width:15%; vertical-align: middle;">회사(기업)정보</td>
                            <td class="tl">
                                <input type="text" v-model="userInfoOptions.company_name" style="width: 90%;" class="form-control" />
                            </td>
                        </tr>
                        <tr>
                            <td style="width:15%; vertical-align: middle;">회사(기관)정보</td>
                            <td class="tl">
                                <input type="text" v-model="userInfoOptions.orderer_department" style="width: 90%;" class="form-control" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </b-col>
          </b-row>
        </b-card>
        <b-card>
          <div slot="header">
            <span class="card-title wise-card-title">적용상품</span>
          </div>
          <b-row>
            <b-col sm="12">
                <table class="table table-bordered oddBackground">
                    <tbody>
                        <tr>
                            <td style="width:15%; vertical-align: middle;">구분</td>
                            <td class="tl" style="width:35%;">
                                <select id="selectOpTypeCode" class="form-control" v-on:change="slotPTypeChange($event)" style="width: 90%;">
                                    <option  v-for="row in pTypeList" :value="row.item_code" :selected="row.item_code === modifyItem.p_type">{{ row.item_name }}</option>
                                </select>
                            </td>
                            <td style="width:15%; vertical-align: middle;">사용권한(다운로드양식)</td>
                            <td class="tl" style="width:35%;">
                                <select id="selectDownloadTypeCode" class="form-control" v-on:change="slotDownloadTypeChange($event)" style="width: 90%;">
                                    <option  v-for="row in pDownloadTypeList" :value="row.item_code" :selected="row.item_code === modifyItem.auth_download_type">{{ row.item_name }}</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:15%; vertical-align: middle;">서비스 제공기간</td>
                            <td class="tl" style="width:35%;">
                                <select id="selectOpTypeCode" class="form-control" v-on:change="slotPeriodTypeChange($event)" style="width: 90%;">
                                    <option  v-for="row in sortedPPeriodList" :value="row.item_code" :selected="row.item_code === modifyItem.period_code">{{ row.item_name }} 개월</option>
                                </select>
                            </td>
                            <td style="width:15%; vertical-align: middle;">이용기간</td>
                            <td class="tl" style="width:35%; vertical-align: middle;">
                                <span id="auth_period" style="margin-right: 5%;">
                                    <DatePicker v-model="modifyItem.auth_start_date_tmp"
                                                type="date"
                                                :lang="datepickerLang"
                                                style="width: 35% !important;"
                                                :clearable="false"
                                                @change="isRangeDateCheck"
                                    />
                                    ~
                                    <DatePicker v-model="modifyItem.auth_end_date_tmp"
                                                type="date"
                                                :lang="datepickerLang"
                                                style="width: 35% !important;"
                                                :clearable="false"
                                                @change="isRangeDateCheck"
                                    />
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </b-col>
          </b-row>
        </b-card>
        <b-card>
          <div slot="header">
            <span class="card-title wise-card-title">결제정보</span>
          </div>
          <b-row>
            <b-col sm="12">
                <table class="table table-bordered oddBackground">
                    <tbody>
                        <tr>
                            <td style="width:15%; vertical-align: middle;">결제금액</td>
                            <td class="tl" style="width:35%;">
                                <input type="text" v-model="modifyItem.price" style="width: 90%;" class="form-control" />
                            </td>
                            <td style="width:15%; vertical-align: middle;">최종 결제금액</td>
                            <td class="tl" style="width:35%; vertical-align: middle;">
                                <b>{{ (modifyItem.price - modifyItem.dc_price) | numberComma }} 원</b>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:15%; vertical-align: middle;">할인금액</td>
                            <td class="tl" style="width:35%; vertical-align: middle;">
                                <input type="text" v-model="modifyItem.dc_price" style="width: 90%;" class="form-control" />
                            </td>
                            <td style="width:15%; vertical-align: middle;">할인 비고</td>
                            <td class="tl" style="width:35%; vertical-align: middle;">
                                <input type="text" v-model="modifyItem.extra_dc_desc" style="width: 90%;" class="form-control" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <div slot="header">
              <span class="card-title wise-card-title" style="margin-right: 2%;">세금계산서 발행 정보</span>
              <b>※ 세금계산서 발행 여부 : </b>
              <c-switch type="text" variant="primary" v-model="modifyItem.tax_yn" on="On" off="Off" :pill="true" :checked="false"/>
          </div>
          <b-row v-if="modifyItem.tax_yn === 'Y'">
            <b-col sm="12">
              <table class="table table-bordered oddBackground">
                <tbody>
                  <tr>
                    <td style="width:15%; vertical-align: middle;">사업자 등록증</td>
                    <td class="tl">
                        <input type="file" class="form-control-file" id="file" ref="blFile" accept=".jpg, .jpeg, .png" style="padding:5px"/>
                    </td>
                  </tr>
                  <tr>
                    <td style="width:15%; vertical-align: middle;">계산서 수신 이메일</td>
                    <td class="tl">
                        <input type="text" v-model="modifyItem.invoice_mail" style="width: 90%;" class="form-control" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row style="float:right">
      <b-col md="6">
        <b-button variant="success" v-on:click="insertArOrder()" style="color:#ffffff; border-radius:5px; cursor:pointer; width:120px; border:1px solid #248847; font-size:15px"><h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 등록</h5></b-button>
      </b-col>
      <b-col md="6">
        <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:120px; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/order/userAuth'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
      </b-col>
    </b-row>
    <b-modal title="유저 정보 검색" size="lg" v-model="userFormModal" @ok="userFormModal = false" no-close-on-backdrop no-close-on-esc hide-footer>
      <userInfoModal v-bind:userInfoOptions="userInfoOptions" v-bind:userFormModal="userFormModal" @childs-event="userModalClose" ref="userInfoModalRef"></userInfoModal>
      <hr />
      <span class="float-right" style="padding-right:20px;">
        <b-button variant="outline-danger" @click="userFormModal = false">닫기</b-button>
      </span>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import userInfoModal from './UserInfoModal';
import productInfoModal from './ProductInfoModal';
import ko from 'vee-validate/dist/locale/ko.js'
import swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import { codeAPI } from '../../common/code.js';
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import cSwitch from '../../components/Switch';

const moment = require("moment");

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  locale: 'ko'
});

export default {
  components: {
    userInfoModal,
    productInfoModal,
    Multiselect,
    DatePicker,
    cSwitch,
  },
  data() {
    return {
      datepickerLang: {
          yearFormat: "YYYY년",
          monthFormat: "M월",
          days:["일","월","화","수","목","금","토"]
      },
      companyFlag: 'R', //수정,등록페이지 값
      endDateCheckYn: 'N',
      userAuthAddType: '',
      userInfoOptions: {
        user_id: '',
        user_name: '',
        company_name: '',
        orderer_department: '',
        mobile: '',
      },
      userAuthInCheckList: [],
      pTypeList: [],
      pPeriodList: [],
      pDownloadTypeList: [],
      productCompanyList: [],
      productInfoOptions: {
        p_code: '',
        dc_result_price: 0,
        price: 0,
        order_product_type: 'ORDER_PRODUCT_CODE_2',
        custom_start_date: '',
        custom_end_date: '',
      },
      userFormModal:false,
      productFormModal:false,
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
      endDate: moment().format('YYYY-MM-DD'),
      startDate: moment().format('YYYY-MM-DD'),
      modifyItem: {
          user_id: '',
          p_type: '',
          p_code: '',
          p_name: '',
          auth_download_type: '',
          order_product_type: 'ORDER_PRODUCT_CODE_2',
          period_code: '',
          auth_start_date_tmp: null,
          auth_end_date_tmp: null,
          auth_start_date: '',
          auth_end_date: '',
          price: 0,
          dc_price: 0,
          amount: 0,

          extra_dc_desc: '',
          invoice_mail: '',
      },
      queryParams: {
          key_cnt: 3,
          fix_yn: 'Y',
      },
    }
  },
  watch: {
        'modifyItem.price': function (value, oldValue) {
            // console.log('price', value, oldValue)
            this.modifyItem.price = value.replace(/[^0-9]/g,'');
        },
        'modifyItem.dc_price': function (value, oldValue) {
            this.modifyItem.dc_price = value.replace(/[^0-9]/g,'');
        },
    },
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    var self = this;
    self.findCodesList();
    self.findDrProductCompanyList();

    setTimeout(() => {
      self.fnGetAmout();
    }, 500);
  },
  methods: {
    insertArOrder() {
      var self = this;

      if(self.userInfoOptions.user_id == ''){
        swal.fire({
          type: 'error',
          title: '아이디를 검색해 주세요.',
          showConfirmButton: false,
          timer: 1500
        })
        return false;
      }

      if(self.modifyItem.price - self.modifyItem.dc_price < 0){
        swal.fire({
          type: 'error',
          title: "최종 결제금액이 0원 미만입니다.",
          showConfirmButton: false,
          timer: 1500
          // showCancelButton: false,
          // confirmButtonColor: '#3085d6',
          // cancelButtonColor: '#d33',
          // confirmButtonText: 'OK'
        })
        return false;
      }

      var token = sessionStorage.getItem("myToken");
      self.queryParams.user_id = self.userInfoOptions.user_id;
      self.queryParams.orderer_name = self.userInfoOptions.name;
      self.queryParams.company = self.userInfoOptions.company_name;
      self.queryParams.department = self.userInfoOptions.orderer_department;
      self.queryParams.mobile = self.userInfoOptions.mobile;

      self.queryParams.dc_price = self.modifyItem.dc_price;
      self.queryParams.extra_dc_desc = self.modifyItem.extra_dc_desc;
      self.queryParams.order_price = self.modifyItem.price;
      self.queryParams.invoice_mail = self.modifyItem.invoice_mail;

      self.queryParams.op_code = self.modifyItem.p_code;
      self.queryParams.op_name = self.modifyItem.p_name;
      self.queryParams.op_type_code = self.modifyItem.p_type;
      self.queryParams.order_product_type = self.modifyItem.order_product_type;
      self.queryParams.custom_start_date = moment(self.modifyItem.auth_start_date_tmp).format('YYYY-MM-DD');
      self.queryParams.custom_end_date = moment(self.modifyItem.auth_end_date_tmp).format('YYYY-MM-DD');

      // console.log(self.queryParams);
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('orderObj', param);

      if(self.modifyItem.tax_yn == 'Y'){
        //썸네일
        if(self.$refs.blFile.files.length > 0){
          data.append('blFile', self.$refs.blFile.files[0])
        }
      }

      self.$http.post('/api/insert/orderUserAuth?access_token='+token, data, null)
        .then((result) => {
          swal.fire({
            type: 'success',
            title: '권한상품 주문이 등록되었습니다.',
            showConfirmButton: false,
            timer: 1500
          }).then(function() {
              window.location = "#/order/userAuth";
          });
      })
    },
    openUserInfoModal() {
      var self = this;
      self.userFormModal = true;
    },
    userModalClose(data) {
      var self = this;
      self.userAuthAddType = data.type;
      self.userInfoOptions = data.userdata;
      self.productInfoOptions = {
        p_code: '',
        dc_result_price: 0,
        price: 0,
        order_product_type: 'ORDER_PRODUCT_CODE_2',
        custom_start_date: '',
        custom_end_date: '',
      };
      self.endDateCheckYn = 'N';
      $('input[name="daterange"]').val('');

      var dataParam = {};
      dataParam.user_id = self.userInfoOptions.user_id;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(dataParam));
      var data = new FormData();
      data.append('userObjs', param);

      self.$http.post('/api/select/selectUserAuthInCheckList?access_token=' + token, data, null)
      .then((result) => {
        self.userAuthInCheckList = result.data;
      })
      // if(self.userAuthAddType == 'addauth'){
      //   if(self.userInfoOptions.use_auth_names.indexOf(',') != -1){
      //       var arr = self.userInfoOptions.use_auth_names.split(",");
      //       var temp = '( 이용중인 상품 : ';
      //       arr.forEach(function (el, idx, arr){
      //         temp += '<span class="badge" style="background-color:#e83264; color:#ffffff; font-size:12px">'+el+'</span>&nbsp;&nbsp;';
      //       });
      //       temp+= ' )';
      //       self.userInfoOptions.use_products = temp;
      //   }else{
      //       self.userInfoOptions.use_products = '( 이용중인 상품 : <span class="badge" style="background-color:#e83264; color:#ffffff; font-size:12px">'+self.userInfoOptions.use_auth_names+'</span> )';
      //   }
      // }
      self.userFormModal = false;
    },
    isRangeDateCheck(){
      // console.log(this.modifyItem.auth_start_date, this.modifyItem.auth_end_date);
      if(this.modifyItem.auth_start_date_tmp > this.modifyItem.auth_end_date_tmp){
          swal.fire({
              text: "이용기간 시작일이 종료일보다 큽니다.",
              type: 'error',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'OK'
            }).then((swalResult) => {
              if (swalResult.value) {

              }
            })
          // 이전 데이터로 초기화
          this.modifyItem.auth_start_date_tmp = moment(this.startDate, 'YYYY-MM-DD').toDate();
          this.modifyItem.auth_end_date_tmp = moment(this.endDate, 'YYYY-MM-DD').toDate();
      }else{

      }
    },
    // 기업 상품 목록
    findDrProductCompanyList() {
        var token = sessionStorage.getItem("myToken");

        var param = encodeURI(JSON.stringify(this.queryParams));
        var reqData = new FormData();
        reqData.append('objs', param);

        this.$http.post('/api/select/drProductAuthList?access_token=' + token, reqData, null)
        .then((result) => {
            const { data } = result;
            // console.log('findDrProductCompanyList', data);
            this.productCompanyList = data;

            // companyFlag R 등록 화면용
            if(this.companyFlag === 'R') this.modifyItem.p_code = this.productCompanyList[0].p_code;
        })
    },
    slotPTypeChange(event) {
        // console.log('slotPTypeChange', event.target.value);
        this.modifyItem.p_type = event.target.value;
    },
    slotDownloadTypeChange(event) {
        this.modifyItem.auth_download_type = event.target.value;
        // 서비스 제공기간, 사용권한 변경시 서비스 이용금액 변경
        this.fnGetAmout();
    },
    slotPeriodTypeChange(event) {
        this.modifyItem.period_code = event.target.value;
        this.fnSetAuthDate(event.target.value);
        // 서비스 제공기간, 사용권한 변경시 서비스 이용금액 변경
        this.fnGetAmout();
    },
    // 서비스 제공기간, 사용권한 변경시 고정 기업 상품의 가격 가져오기
    fnGetAmout() {
        this.productCompanyList.forEach(data => {
            // console.log(data);
            const { p_code, p_name, auth_download_type, period_code, price } = data;
            if(auth_download_type === this.modifyItem.auth_download_type && period_code === this.modifyItem.period_code){
                // console.log('!!', p_code, auth_download_type, period_code, price);
                this.modifyItem.price = price.toString();
                this.modifyItem.p_code = p_code;
                this.modifyItem.p_name = p_name;
            }
        });
    },
    // 등록화면용 기본 일자 세팅
    fnSetAuthDate(term) {
        const nowDate = new Date();
        this.modifyItem.auth_start_date_tmp = moment(nowDate).toDate();
        if(term === '' || term === 'PRDT_PERIOD_1'){
            this.modifyItem.auth_end_date_tmp = moment(nowDate).toDate();
        }else {
            // this.sortedPPeriodList
            const period = _.find(this.sortedPPeriodList, (o) => o.item_code === term);
            // 값만 있는 개월
            this.modifyItem.auth_end_date_tmp = moment(nowDate).add(period.item_name, 'M').toDate();
        }
    },
    findCodesList() {
        var token = sessionStorage.getItem("myToken");
        // PRDT_TYPE(상품구분) > PRDT_TYPE_2(계정상품) > 코드 목록
        this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=PRDT_TYPE_2')
        .then((result) => {
                const { data } = result;
                // console.log('PRDT_TYPE_2', data);
                this.pTypeList = data;

                // companyFlag R 등록 화면용
                if(this.companyFlag === 'R') this.modifyItem.p_type = this.pTypeList[0].item_code;
        })
        // PRDT_PERIOD(상품기간) > 코드 목록
        this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=PRDT_PERIOD')
        .then((result) => {
                const { data } = result;
                // console.log('PRDT_PERIOD', data);
                this.pPeriodList = data;

                // companyFlag R 등록 화면용
                if(this.companyFlag === 'R') {
                    this.modifyItem.period_code = this.pPeriodList[0].item_code;
                    this.fnSetAuthDate('');
                }
        })
        // AUTH_DOWNLOAD_TYPE(계정권한 다운로드 형식) > 코드목록
        this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=AUTH_DOWNLOAD_TYPE')
        .then((result) => {
                const { data } = result;
                // console.log('AUTH_DOWNLOAD_TYPE', data);
                this.pDownloadTypeList = data;

                // companyFlag R 등록 화면용
                if(this.companyFlag === 'R') this.modifyItem.auth_download_type = this.pDownloadTypeList[0].item_code;
        })

    },
  },
  computed: {
      sortedPPeriodList() {
        // 배열을 정렬하여 새로운 배열을 반환
        return this.pPeriodList.sort((a, b) => a.item_seq < b.item_seq);
      }
  },
}

$(document).ready(function(){
});

</script>
<style lang="css" scoped>
.buttons {
  margin-top: 35px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}


.p20{
    padding:20px
}

.normal {
    background-color: grey;
}

.dragArea{
    min-height: 10px;
}

.sortable-chosen {
    opacity: 0.7;
    background-color:#dcdcdc;
}

.sortable-ghost {
    background-color:#dcdcdc;
}
.handle {
    padding: 5px;
    margin-right: 10px;
    border: solid #000 1px;
    cursor: move;
}

span.error {
  color: #9F3A38;
}


#VueTables__search_UBume {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}

.oddBackground td:nth-child(odd) {
  background:#dcdcdc;
  font-weight: 600;
}
.theader{
  background:#dcdcdc;
  font-weight: 600;
}
</style>
<style src="daterangepicker/daterangepicker.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/order/OrderUserAuthForm.vue